import { create } from "zustand";
import type { NotificationData, NotificationViewModel } from "@/common/types/notification";

interface NotificationState {
  items: NotificationViewModel[];
  add: (params: NotificationData) => string;
  close: (id: string, duration: number) => void;
  remove: (id: string) => void;
}

const buildDedupeKey = (p: NotificationData) => JSON.stringify([
  p.variant,
  p.title,
  p.description ?? "",
  p.actionButton?.title ?? "",
  p.secondaryButton?.title ?? "",
]);

export const useNotificationStore = create<NotificationState>()((set, get) => ({
  items: [],

  add: (data) => {
    const id = buildDedupeKey(data);

    set((state) => ({
      items: [
        { id, ...data, isClosing: false },
        ...state.items.filter((n) => n.id !== id),
      ],
    }));

    return id;
  },

  close: (id, duration) => {
    const current = get().items.find((n) => n.id === id);
    if (!current || current.isClosing) {
      return;
    }

    set((state) => ({
      items: state.items.map((n) =>
        n.id === id ? { ...n, isClosing: true } : n
      ),
    }));

    window.setTimeout(() => {
      get().remove(id);
    }, duration);
  },

  remove: (id) => {
    set((state) => ({
      items: state.items.filter((n) => n.id !== id),
    }));
  },
}));
